export default __webpack_public_path__ + "static/media/WildWater_05.dcbcea66.png";